import React, { useState, useEffect } from "react";

const images = [
  "/img/new.png",
   "/img/1.png",
   "/img/new3.png",
  "/img/2.png",

    
 ];

const NewAdImage = () => {
  const [current, setCurrent] = useState(0);

  // 🔥 Auto Slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000); // 3 sec

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        padding: "10px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          width: "100%",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        <img
          src={images[current]}
          alt="Ad Banner"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            borderRadius: "12px",
            transition: "0.5s",
          }}
        />

        {/* 🔘 Dots */}
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            width: "100%",
            textAlign: "center",
          }}
        >
          {images.map((_, index) => (
            <span
              key={index}
              onClick={() => setCurrent(index)}
              style={{
                display: "inline-block",
                width: "8px",
                height: "8px",
                margin: "0 4px",
                borderRadius: "50%",
                background: current === index ? "#fff" : "#ccc",
                cursor: "pointer",
              }}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewAdImage;